/* eslint-disable eqeqeq */

import { mergeAttributes } from "@tiptap/core";
import TiptapImage from "@tiptap/extension-image";
import { ReactNodeViewRenderer } from "@tiptap/react";

import ImageView from "../../extensions/Image/components/ImageView";

export const Image = TiptapImage.extend({
	addOptions() {
		return {
			...this.parent?.(),
			inline: false,
			content: "",
			marks: "",
			group: "block",
			draggable: false,
			selectable: true,
			atom: true
		};
	},
	addAttributes() {
		return {
			...this.parent?.(),
			width: {
				default: null,
				parseHTML: element => {
					const width = element.style.width || element.getAttribute("width") || null;
					return width == undefined ? null : Number.parseInt(width, 10);
				},
				renderHTML: attributes => {
					return {
						width: attributes.width
					};
				}
			},
			align: {
				default: null,
				parseHTML: element => {
					if (element) {
						const align = element.style.textAlign;
						return align || "left";
					}
					return "left";
				},
				renderHTML: attributes => {
					if (!attributes.align) {
						return {};
					}
					return {
						align: attributes.align
					};
				}
			}
		};
	},

	addNodeView() {
		return ReactNodeViewRenderer(ImageView);
	},
	addCommands() {
		return {
			...this.parent?.(),
			updateImage:
				options =>
					({ commands }) => {
						return commands.updateAttributes(this.name, options);
					},
			setAlignImage:
				align =>
					({ commands }) => {
						return commands.updateAttributes(this.name, { align });
					}
		};
	},
	renderHTML({ HTMLAttributes }) {
		const { align } = HTMLAttributes;
		const sanitizedOptionsHTMLAttributes = { ...this.options.HTMLAttributes };
		delete sanitizedOptionsHTMLAttributes.align;
		const sanitizedHTMLAttributes = { ...HTMLAttributes };
		delete sanitizedHTMLAttributes.align;

		const style = align ? `text-align: ${align};` : "";
		return [
			"div",
			{
				style,
				class: "image"
			},
			[
				"img",
				mergeAttributes(
					{
						height: "auto",
					},
					sanitizedOptionsHTMLAttributes,
					sanitizedHTMLAttributes
				)
			]
		];
	},
	parseHTML() {
		return [
			{
				tag: "div[class=image]",
				getAttrs: element => {
					const img = element.querySelector("img");
					const width = img?.getAttribute("width");
					return {
						src: img?.getAttribute("src"),
						alt: img?.getAttribute("alt"),
						title: img?.getAttribute("title"),
						width: width ? Number.parseInt(width, 10) : null
					};
				}
			}
		];
	}
});

export default Image;
